export default "__VITE_ASSET__CGdV7V3f__"